export default "__VITE_PUBLIC_ASSET__10bd6755__"